import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const GreenToRedPositionsLine = observer(({
  tradePlanId,
  state,
  priceToBreak,
  inRightDirectionPct,
  retracePct,
  size,
  scaleY,
  portalRef,
}) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const paused = tradePlan?.exitTactics['GREEN_TO_RED_POSITIONS']?.paused ?? null;

  const json = {
    Category: 'Exit Tactic',
    Type: 'G2R Pos.',
    'Break Price': ApplyRounding(Number(priceToBreak), 2),
    'Retrace Pct': retracePct ? Number(retracePct) * 100 + '%' : 'NA',
    'Right Direction Pct': inRightDirectionPct ? Number(inRightDirectionPct) * 100 + '%' : 'NA',
  };
  return (
    <>
      {scaleY ? (
        <>
          {paused && Number(priceToBreak) > 0 && Number(priceToBreak) < 1000000 ? (
            <line
              strokeDasharray={4}
              stroke={state === 'RIGHT_DIRECTION' ? colors.orange : colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          ) : (
            <line
              stroke={state === 'RIGHT_DIRECTION' ? colors.orange : colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          )}

          <HoverBox
            json={json}
            topBoundary={scaleY(Number(priceToBreak)) - 2}
            bottomBoundary={scaleY(Number(priceToBreak)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
          />
        </>
      ) : null}
    </>
  );
});

GreenToRedPositionsLine.propTypes = {
  state: PropTypes.string,
  priceToBreak: PropTypes.string,
  candleDuration: PropTypes.number,
  inRightDirectionPct: PropTypes.number,
  retracePct: PropTypes.number,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
  tradePlanId: PropTypes.any
};
